var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{class:_vm.$style.textarea,style:({ height: _vm.isHeight }),attrs:{"required":_vm.required,"placeholder":_vm.placeholder,"name":_vm.name,"maxlength":_vm.maxLength},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('isInput', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }